var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "fieldset",
        {
          staticClass: "mt-3 mb-0 custom-fieldset",
          staticStyle: { width: "100%" }
        },
        [
          _c(
            "legend",
            [
              _vm.$store.state.DelegationOrder.readonly !== true
                ? [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          width: "0",
                          display: "inline-flex",
                          position: "relative",
                          left: "-75px"
                        }
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { fab: "", "x-small": "", color: "accent" },
                            on: { click: _vm.newTravelService }
                          },
                          [
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v("fa-plus")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "delegation-order-travel-service-import",
                      {
                        staticStyle: {
                          width: "0",
                          display: "inline-flex",
                          position: "relative",
                          left: "-40px",
                          top: "-2px"
                        },
                        attrs: {
                          travel_service_order_ids: _vm.travelServiceOrderIds
                        },
                        on: {
                          "update:travel_service_order_ids": function($event) {
                            _vm.travelServiceOrderIds = $event
                          }
                        }
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              fab: "",
                              "x-small": "",
                              color: "grey darken-2",
                              dark: ""
                            }
                          },
                          [
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v("fa-file-import")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm._v(
                " " +
                  _vm._s(_vm.$t("delegationOrder.assignedTravelOrders")) +
                  " "
              )
            ],
            2
          ),
          _vm.travelServiceOrderIds.length === 0
            ? [_vm._v(_vm._s(_vm.$t("delegationOrder.noAssignedTravelOrders")))]
            : _c(
                "div",
                [
                  _c("order-list-data-table", {
                    attrs: {
                      "travel-service-orders": _vm.travelServiceOrders,
                      unpin: ""
                    },
                    on: {
                      changed: function($event) {
                        return _vm.downloadTravelServiceSelectedList()
                      },
                      edit: function(id) {
                        return _vm.editTravelService(id)
                      },
                      "choose-offer": function(id) {
                        return _vm.chooseOfferTravelService(id)
                      },
                      approval: function(id) {
                        return _vm.approvalTravelService(id)
                      },
                      booked: function(id) {
                        return _vm.bookedTravelService(id)
                      },
                      unpin: _vm.unpinMethod,
                      message: function(val) {
                        return _vm.$router.push(
                          "/travel-service/item-details/" + val
                        )
                      }
                    }
                  })
                ],
                1
              )
        ],
        2
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "90%" },
          model: {
            value: _vm.newTravelServiceOrderDialog,
            callback: function($$v) {
              _vm.newTravelServiceOrderDialog = $$v
            },
            expression: "newTravelServiceOrderDialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "pt-3" },
            [
              _c(
                "v-card-text",
                [
                  _c("order-services", {
                    on: {
                      cancel: function($event) {
                        _vm.newTravelServiceOrderDialog = false
                      },
                      saved: function(ids) {
                        return _vm.saved(ids)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }